/*=========================================================================================
  File Name: modulePrecripteur.js
  Description: module prescripteur
  ----------------------------------------------------------------------------------------
==========================================================================================*/


import state from './moduleSmsMarketingState.js'
import mutations from './moduleSmsMarketingMutations.js'
import actions from './moduleSmsMarketingActions.js'
import getters from './moduleSmsMarketingGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

